export default __webpack_public_path__ + "assets/png/ef800c68cc07988e958bdb834aff21a7.png";